import React from 'react';
import PropTypes from 'prop-types';

const circleButtonDefaultPropOnClick = () => {};
const CircleButton = ({
  onClick = circleButtonDefaultPropOnClick,
  ariaLabel,
  children,
  selected = false,
  disabled = false,
  className = ''
}) => {
  const outerFill = selected ? 'bg-gray-700' : '';
  const textClass = disabled ? 'text-gray-500 cursor-not-allowed' : '';

  return (
    <button
      type="button"
      className={`flex justify-center items-center m-3 w-8 h-8 bg-white shadow-lg rounded-full ${outerFill} ${textClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

CircleButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  children: PropTypes.element.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default CircleButton;
